import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GeneralCollateralHistory } from '../../interfaces/general-collateral/general-collateral-history';
import { OrderGroupsService } from '../../services/order-groups/order-groups.service';
import { Order } from '../../interfaces/orders/order';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'lib-general-collateral-history-popup',
    templateUrl: './general-collateral-history-popup.component.html',
    styleUrls: ['./general-collateral-history-popup.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GeneralCollateralHistoryPopupComponent implements OnInit {
  order!: Order;

  protected history: GeneralCollateralHistory[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Order,
    private orderGroupsService: OrderGroupsService) { 
      this.order = data;
    }

  ngOnInit(): void {
    this.orderGroupsService.getGeneralCollateralHistory(this.order.orderGroup?.id ?? '')
      .subscribe(history => {
        const indexOfCurrentOrder = history.findIndex(h => this.order.lien?.registrationResults?.some(results => results.registrationNumber === h.registrationNumber));

        if(indexOfCurrentOrder === -1) {
          this.history = history;
        } else {
          this.history = history.slice(0, indexOfCurrentOrder + 1);
        }
      });
  }
}
